import type {ResidentClaimStartData} from "../types";

type ClaimContextCardProps = {
  property: ResidentClaimStartData["property"];
  household: ResidentClaimStartData["household"];
};

export default function ClaimContextCard({property, household}: ClaimContextCardProps) {
  return (
    <div className="mb-6 flex flex-col gap-2 rounded-lg border border-border bg-muted/50 p-4">
      <div>
        <p className="text-sm font-medium text-muted-foreground">Property</p>
        <p className="font-semibold text-foreground">{property.name}</p>
        <p className="text-sm text-muted-foreground">{property.address}</p>
      </div>
      <div>
        <p className="text-sm font-medium text-muted-foreground">Unit</p>
        <p className="text-foreground">
          {household.unit_number} — {household.name}
        </p>
      </div>
    </div>
  );
}
